module.exports = __webpack_public_path__ + "img/Katana.924ab12f.png";